import { QueryClient } from '@tanstack/react-query';

// Export queryClient so it can be used to clear cache on logout
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
    },
  },
});


